import BaseModel from "./base/baseModel";
import TiposPessoa from "./enum/tiposPessoa";
import Ufs from "./enum/ufs";

export default class ClienteEnderecoEntregaModel extends BaseModel {
    id?: number = null;
    clienteId?: number = null;
    cep: string = null;
    estadoId?: Ufs = null;
    cidadeId?: number = null;
    cidade: string = null;
    estado: string = null;
    endereco: string = null;
    bairro: string = null;
    numero: string = null;
    complemento: string = null;
    enderecoPadrao = false;
    ativo = true;
    seqEnvioEntrega?: number = null;
    seqEnderecoEntrega?: number = null;
    cpfCnpjEntrega: string = null;
    tipoPessoaEntrega?: TiposPessoa = null;
    // Campos do endereço de entrega de terceiro — ainda não persistidos no backend
    nomeEntrega: string = null;
    telefoneEntrega: string = null;
    cepInicial: string = null;
    cepFinal: string = null;
}
